<script lang="ts">
  import { untrack } from 'svelte';
  import Button from '$lib/ui/Button.svelte';
  import Spinner from '$lib/ui/Spinner.svelte';
  import { go, setCurrentRoom } from '$lib/ui/nav.svelte';
  import { gate, openGate } from '$lib/ui/session.svelte';
  import { me, redeemRoomInvite } from './api';
  import { roomInvitation } from './invite-handoff';

  const pending = roomInvitation;
  const port = {
    ensureAccount: me,
    redeem: redeemRoomInvite,
    navigate: (roomId: string) => {
      setCurrentRoom(roomId);
      go(`/room/${encodeURIComponent(roomId)}`, { replace: true });
    }
  };
  $effect(() => {
    if ($pending.phase !== 'pending' || gate.state !== 'open') return;
    untrack(() => void pending.resume(true, port));
  });
  async function retry(): Promise<void> {
    await openGate();
    await pending.resume(gate.state === 'open', port);
  }
</script>

<div class="invitation">
  <h1>Room invitation</h1>
  {#if $pending.phase === 'error'}
    <p role="alert">{$pending.error}</p>
    <div class="actions">
      {#if $pending.retryable}<Button variant="primary" onclick={retry}>Try again</Button>{/if}
      <Button onclick={() => { pending.dismiss(); go('/'); }}>Back to browsing</Button>
    </div>
  {:else}
    <p role="status"><Spinner size={16} /> Opening your invitation…</p>
    <Button onclick={() => { pending.dismiss(); go('/'); }}>Cancel</Button>
  {/if}
</div>

<style>
  .invitation { max-width: 48ch; margin: 12dvh auto; padding: var(--space-5); display: grid; gap: var(--space-4); }
  h1 { font-size: var(--text-xl); }
  p { color: var(--text-dim); }
  .actions { display: flex; flex-wrap: wrap; gap: var(--space-2); }
</style>
